import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { FormGroup, H2, H4, HTMLSelect } from '@blueprintjs/core';
import { Paper } from '@material-ui/core';

import DetailByReal from './DetailByReal';
import './Real.css';


class RealByCorpus extends React.PureComponent {

  state = {
    detailStats: this.props.detailStats, // freqByReal, specByReal, dispByReal
    tokenId:'full', // full realization, or by token id (1, 2, 3...)
  }

  onTokenIdChange = (e) => {
    e.preventDefault();
    this.setState({ tokenId: e.target.value });
  }
  onDetailChange = (e) => {
    e.preventDefault();
    this.setState({ detailStats: e.target.value });
  }

  render() {
    const { corpusStats, t, estimatedResults } = this.props;


    return(
    <>
      { this.props.displayName &&
        <div style={{color:"green",marginBottom:"20px"}}>{t('subCorpusName')} : {this.props.name}</div>
      } 
      <Paper className="margin-bottom-1-5-rem padding-1-rem">
        <H2>{t('realizations')}</H2>
 
        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('detailedStats')}</u></H4>
          <FormGroup label={t('fullRealOrBytoken')} labelFor='fullRealOrBytoken' inline={true}>
            <HTMLSelect id='fullRealOrBytoken' name='fullRealOrBytoken' onChange={this.onTokenIdChange} value={this.state.tokenId}>
              <option value='full'>{t('fullRealization')}</option>
              {
                corpusStats.realizationsByToken?
                  Object.keys(corpusStats.realizationsByToken).map( id => <option key={id} value={id}>token {id}</option>):
                  ""
              }
           
            </HTMLSelect>
          </FormGroup>

          <FormGroup label={t('type')} labelFor='statsDetails' inline={true}>
            <HTMLSelect id='statsDetails' name='statsDetails' onChange={this.onDetailChange} value={this.state.detailStats}>
              <option value='freqByReal'>{t('freqByReal')}</option>
              { this.state.tokenId==='full' && 
                <>
                  <option value='specByReal'>{t('specByReal')}</option>
                  <option value='dispByReal'>{t('dispByReal')}</option>
                </>
              }
            </HTMLSelect>
          </FormGroup>
        </div>

        <DetailByReal
            tokenId={this.state.tokenId}
            corpusStats={this.state.tokenId==='full'? corpusStats.realizations: corpusStats.realizationsByToken[this.state.tokenId] }
            type={this.state.detailStats}
            incompleteExtraction={estimatedResults}
            realSpec={this.props.realSpec}
        />
      </Paper>
    </>
    );
  }
}

RealByCorpus.propTypes = {
  name: PropTypes.string,
  displayName : PropTypes.bool,
  corpusStats: PropTypes.object,
  realSpec: PropTypes.object,
  detailStats: PropTypes.string,
  estimatedResults: PropTypes.bool,
};

export default withTranslation()(RealByCorpus);
